import { addYears, startOfYear } from 'date-fns'
import {
    call,
    put,
    select,
    takeLatest,
} from 'redux-saga/effects'

import { getCheckedFormOptionsValue } from '../../@paco/helpers/types/formOption'

import {
    PAGE_SIZES,
    TIME_MODES,
    TOAST_TYPE_FAIL,
    TOAST_TYPE_PASS,
} from '../../constants'
import {
    getIncludes,
    getUserTracks,
    postSyncTvt,
} from '../../helpers/api/tracksApi'
import { getTracksInDateRangeLegacy } from '../../helpers/api-ts/track'
import { startOfMonth } from '../../helpers/date'
import { translate } from '../../helpers/translations/translator'
import {
    APP_SAGA_ADD_TOAST,
    PAGINATION_SET_PAGINATION,
    TRACKS_FAILURE,
    TRACKS_GET_USER_TRACKS_FAILURE,
    TRACKS_GET_USER_TRACKS_REQUEST,
    TRACKS_GET_USER_TRACKS_SUCCESS,
    TRACKS_REQUEST,
    TRACKS_SAGA_GET_TRACKS,
    TRACKS_SAGA_GET_USER_TRACKS,
    TRACKS_SAGA_SYNC_TVT,
    TRACKS_SUCCESS,
    TRACKS_SYNC_TVT_FAILURE,
    TRACKS_SYNC_TVT_REQUEST,
    TRACKS_SYNC_TVT_SUCCESS,
} from '../actionTypes'

function* fetchTracks(action) {
    yield put({ type: TRACKS_REQUEST, trackType: action.trackType })

    try {
        const {
            filterReducer,
            paginationReducer,
            weekNavigatorReducer,
            globalFiltersReducer,
        } = yield select()

        let { startDate, endDate } = weekNavigatorReducer
        const { trackType } = action
        const { mode } = weekNavigatorReducer
        const { filter } = filterReducer
        const { departmentOptions } = globalFiltersReducer
        const departmentIds = getCheckedFormOptionsValue(departmentOptions)

        // Weeknavigator was originally made for calendars, so we apply a small correction
        // to startDate here
        if (mode === TIME_MODES.MONTH) {
            startDate = startOfMonth(endDate)
        }

        if (mode === TIME_MODES.ALL) {
            startDate = startOfYear(addYears(new Date(), -10))
            endDate = new Date()
        }

        const response = yield call(() => getTracksInDateRangeLegacy(
            startDate,
            endDate,
            action.trackType,
            {
                departments: departmentIds,
                employeeSearch: filter.employeeSearch,
                employeeContractTypes: filter.employeeContractTypes,
            },
            {
                number: paginationReducer.number,
                size: PAGE_SIZES.TRACKS[trackType],
            },
            getIncludes(action.trackType),
        ))

        const { pagination, data } = response

        if (pagination) {
            yield put({
                type: PAGINATION_SET_PAGINATION,
                pages: pagination.pages,
                size: pagination.size,
            })
        }

        yield put({ type: TRACKS_SUCCESS, tracks: data })
    } catch (error) {
        yield put({ type: TRACKS_FAILURE, errors: [error] })
    }
}

function* syncTvt(action) {
    yield put({ type: TRACKS_SYNC_TVT_REQUEST })
    try {
        const { payrollPeriod } = action
        yield call(() => postSyncTvt(payrollPeriod))

        yield put({ type: TRACKS_SYNC_TVT_SUCCESS })
        yield put({ type: APP_SAGA_ADD_TOAST, toast: translate('pages.tracks.syncTvtSuccess'), toastType: TOAST_TYPE_PASS })
    } catch (error) {
        yield put({ type: APP_SAGA_ADD_TOAST, toast: translate('common.loketUnknownError'), toastType: TOAST_TYPE_FAIL })
        yield put({ type: TRACKS_SYNC_TVT_FAILURE, error })
    }
}

function* fetchUserTracks({ userId, date }) {
    yield put({ type: TRACKS_GET_USER_TRACKS_REQUEST })
    try {
        const response = yield getUserTracks(userId, date)
        const tracks = response ? response.data : []

        yield put({ type: TRACKS_GET_USER_TRACKS_SUCCESS, tracks })
    } catch (error) {
        console.error(error)
        yield put({ type: TRACKS_GET_USER_TRACKS_FAILURE })
    }
}

export default function* tracksWatcher() {
    yield takeLatest(TRACKS_SAGA_GET_TRACKS, fetchTracks)
    yield takeLatest(TRACKS_SAGA_GET_USER_TRACKS, fetchUserTracks)
    yield takeLatest(TRACKS_SAGA_SYNC_TVT, syncTvt)
}
